"use strict";

var _objectSpread = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _regeneratorRuntime = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var cov_du7neo097 = function () {
  var path = "/Volumes/Github-Projects/gitea-react-toolkit/src/components/file/useFile.js";
  var hash = "ea63f106e463ef3ea550a0018ba2ec4740364486";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/Github-Projects/gitea-react-toolkit/src/components/file/useFile.js",
    statementMap: {
      "0": {
        start: {
          line: 23,
          column: 26
        },
        end: {
          line: 23,
          column: 36
        }
      },
      "1": {
        start: {
          line: 24,
          column: 26
        },
        end: {
          line: 24,
          column: 36
        }
      },
      "2": {
        start: {
          line: 25,
          column: 66
        },
        end: {
          line: 25,
          column: 95
        }
      },
      "3": {
        start: {
          line: 27,
          column: 17
        },
        end: {
          line: 27,
          column: 44
        }
      },
      "4": {
        start: {
          line: 28,
          column: 17
        },
        end: {
          line: 28,
          column: 79
        }
      },
      "5": {
        start: {
          line: 30,
          column: 32
        },
        end: {
          line: 30,
          column: 42
        }
      },
      "6": {
        start: {
          line: 34,
          column: 6
        },
        end: {
          line: 36,
          column: 4
        }
      },
      "7": {
        start: {
          line: 38,
          column: 30
        },
        end: {
          line: 38,
          column: 98
        }
      },
      "8": {
        start: {
          line: 40,
          column: 17
        },
        end: {
          line: 42,
          column: 8
        }
      },
      "9": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 41,
          column: 19
        }
      },
      "10": {
        start: {
          line: 44,
          column: 15
        },
        end: {
          line: 48,
          column: 18
        }
      },
      "11": {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 47,
          column: 5
        }
      },
      "12": {
        start: {
          line: 46,
          column: 6
        },
        end: {
          line: 46,
          column: 34
        }
      },
      "13": {
        start: {
          line: 50,
          column: 15
        },
        end: {
          line: 63,
          column: 84
        }
      },
      "14": {
        start: {
          line: 51,
          column: 4
        },
        end: {
          line: 62,
          column: 5
        }
      },
      "15": {
        start: {
          line: 52,
          column: 20
        },
        end: {
          line: 54,
          column: 8
        }
      },
      "16": {
        start: {
          line: 57,
          column: 22
        },
        end: {
          line: 57,
          column: 53
        }
      },
      "17": {
        start: {
          line: 59,
          column: 6
        },
        end: {
          line: 61,
          column: 9
        }
      },
      "18": {
        start: {
          line: 65,
          column: 21
        },
        end: {
          line: 81,
          column: 68
        }
      },
      "19": {
        start: {
          line: 68,
          column: 4
        },
        end: {
          line: 80,
          column: 5
        }
      },
      "20": {
        start: {
          line: 69,
          column: 20
        },
        end: {
          line: 74,
          column: 8
        }
      },
      "21": {
        start: {
          line: 76,
          column: 6
        },
        end: {
          line: 79,
          column: 7
        }
      },
      "22": {
        start: {
          line: 77,
          column: 8
        },
        end: {
          line: 77,
          column: 30
        }
      },
      "23": {
        start: {
          line: 78,
          column: 8
        },
        end: {
          line: 78,
          column: 30
        }
      },
      "24": {
        start: {
          line: 83,
          column: 16
        },
        end: {
          line: 92,
          column: 39
        }
      },
      "25": {
        start: {
          line: 84,
          column: 4
        },
        end: {
          line: 86,
          column: 5
        }
      },
      "26": {
        start: {
          line: 85,
          column: 6
        },
        end: {
          line: 85,
          column: 26
        }
      },
      "27": {
        start: {
          line: 88,
          column: 4
        },
        end: {
          line: 90,
          column: 5
        }
      },
      "28": {
        start: {
          line: 89,
          column: 6
        },
        end: {
          line: 89,
          column: 19
        }
      },
      "29": {
        start: {
          line: 91,
          column: 4
        },
        end: {
          line: 91,
          column: 13
        }
      },
      "30": {
        start: {
          line: 94,
          column: 15
        },
        end: {
          line: 101,
          column: 65
        }
      },
      "31": {
        start: {
          line: 95,
          column: 4
        },
        end: {
          line: 100,
          column: 5
        }
      },
      "32": {
        start: {
          line: 96,
          column: 6
        },
        end: {
          line: 98,
          column: 9
        }
      },
      "33": {
        start: {
          line: 99,
          column: 6
        },
        end: {
          line: 99,
          column: 19
        }
      },
      "34": {
        start: {
          line: 103,
          column: 28
        },
        end: {
          line: 113,
          column: 59
        }
      },
      "35": {
        start: {
          line: 104,
          column: 4
        },
        end: {
          line: 112,
          column: 5
        }
      },
      "36": {
        start: {
          line: 105,
          column: 23
        },
        end: {
          line: 107,
          column: 8
        }
      },
      "37": {
        start: {
          line: 109,
          column: 6
        },
        end: {
          line: 111,
          column: 7
        }
      },
      "38": {
        start: {
          line: 110,
          column: 8
        },
        end: {
          line: 110,
          column: 25
        }
      },
      "39": {
        start: {
          line: 115,
          column: 2
        },
        end: {
          line: 122,
          column: 38
        }
      },
      "40": {
        start: {
          line: 116,
          column: 23
        },
        end: {
          line: 116,
          column: 52
        }
      },
      "41": {
        start: {
          line: 117,
          column: 21
        },
        end: {
          line: 117,
          column: 67
        }
      },
      "42": {
        start: {
          line: 119,
          column: 4
        },
        end: {
          line: 121,
          column: 5
        }
      },
      "43": {
        start: {
          line: 120,
          column: 6
        },
        end: {
          line: 120,
          column: 13
        }
      },
      "44": {
        start: {
          line: 124,
          column: 23
        },
        end: {
          line: 124,
          column: 54
        }
      },
      "45": {
        start: {
          line: 126,
          column: 2
        },
        end: {
          line: 130,
          column: 33
        }
      },
      "46": {
        start: {
          line: 127,
          column: 4
        },
        end: {
          line: 129,
          column: 5
        }
      },
      "47": {
        start: {
          line: 128,
          column: 6
        },
        end: {
          line: 128,
          column: 31
        }
      },
      "48": {
        start: {
          line: 132,
          column: 2
        },
        end: {
          line: 136,
          column: 32
        }
      },
      "49": {
        start: {
          line: 133,
          column: 4
        },
        end: {
          line: 135,
          column: 5
        }
      },
      "50": {
        start: {
          line: 134,
          column: 6
        },
        end: {
          line: 134,
          column: 14
        }
      },
      "51": {
        start: {
          line: 138,
          column: 2
        },
        end: {
          line: 143,
          column: 23
        }
      },
      "52": {
        start: {
          line: 139,
          column: 4
        },
        end: {
          line: 142,
          column: 5
        }
      },
      "53": {
        start: {
          line: 140,
          column: 6
        },
        end: {
          line: 140,
          column: 14
        }
      },
      "54": {
        start: {
          line: 141,
          column: 6
        },
        end: {
          line: 141,
          column: 24
        }
      },
      "55": {
        start: {
          line: 145,
          column: 18
        },
        end: {
          line: 152,
          column: 3
        }
      },
      "56": {
        start: {
          line: 154,
          column: 21
        },
        end: {
          line: 170,
          column: 3
        }
      },
      "57": {
        start: {
          line: 172,
          column: 18
        },
        end: {
          line: 172,
          column: 23
        }
      },
      "58": {
        start: {
          line: 174,
          column: 2
        },
        end: {
          line: 182,
          column: 3
        }
      },
      "59": {
        start: {
          line: 175,
          column: 4
        },
        end: {
          line: 175,
          column: 36
        }
      },
      "60": {
        start: {
          line: 176,
          column: 9
        },
        end: {
          line: 182,
          column: 3
        }
      },
      "61": {
        start: {
          line: 177,
          column: 4
        },
        end: {
          line: 181,
          column: 5
        }
      },
      "62": {
        start: {
          line: 178,
          column: 6
        },
        end: {
          line: 178,
          column: 36
        }
      },
      "63": {
        start: {
          line: 180,
          column: 6
        },
        end: {
          line: 180,
          column: 36
        }
      },
      "64": {
        start: {
          line: 184,
          column: 2
        },
        end: {
          line: 189,
          column: 4
        }
      },
      "65": {
        start: {
          line: 192,
          column: 0
        },
        end: {
          line: 215,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "useFile",
        decl: {
          start: {
            line: 14,
            column: 9
          },
          end: {
            line: 14,
            column: 16
          }
        },
        loc: {
          start: {
            line: 22,
            column: 3
          },
          end: {
            line: 190,
            column: 1
          }
        },
        line: 22
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 40,
            column: 29
          },
          end: {
            line: 40,
            column: 30
          }
        },
        loc: {
          start: {
            line: 40,
            column: 40
          },
          end: {
            line: 42,
            column: 3
          }
        },
        line: 40
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 44,
            column: 27
          },
          end: {
            line: 44,
            column: 28
          }
        },
        loc: {
          start: {
            line: 44,
            column: 48
          },
          end: {
            line: 48,
            column: 3
          }
        },
        line: 44
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 50,
            column: 27
          },
          end: {
            line: 50,
            column: 28
          }
        },
        loc: {
          start: {
            line: 50,
            column: 39
          },
          end: {
            line: 63,
            column: 3
          }
        },
        line: 50
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 65,
            column: 33
          },
          end: {
            line: 65,
            column: 34
          }
        },
        loc: {
          start: {
            line: 67,
            column: 8
          },
          end: {
            line: 81,
            column: 3
          }
        },
        line: 67
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 83,
            column: 28
          },
          end: {
            line: 83,
            column: 29
          }
        },
        loc: {
          start: {
            line: 83,
            column: 34
          },
          end: {
            line: 92,
            column: 3
          }
        },
        line: 83
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 94,
            column: 27
          },
          end: {
            line: 94,
            column: 28
          }
        },
        loc: {
          start: {
            line: 94,
            column: 46
          },
          end: {
            line: 101,
            column: 3
          }
        },
        line: 94
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 103,
            column: 40
          },
          end: {
            line: 103,
            column: 41
          }
        },
        loc: {
          start: {
            line: 103,
            column: 52
          },
          end: {
            line: 113,
            column: 3
          }
        },
        line: 103
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 115,
            column: 12
          },
          end: {
            line: 115,
            column: 13
          }
        },
        loc: {
          start: {
            line: 115,
            column: 18
          },
          end: {
            line: 122,
            column: 3
          }
        },
        line: 115
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 126,
            column: 12
          },
          end: {
            line: 126,
            column: 13
          }
        },
        loc: {
          start: {
            line: 126,
            column: 18
          },
          end: {
            line: 130,
            column: 3
          }
        },
        line: 126
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 132,
            column: 12
          },
          end: {
            line: 132,
            column: 13
          }
        },
        loc: {
          start: {
            line: 132,
            column: 18
          },
          end: {
            line: 136,
            column: 3
          }
        },
        line: 132
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 138,
            column: 12
          },
          end: {
            line: 138,
            column: 13
          }
        },
        loc: {
          start: {
            line: 138,
            column: 18
          },
          end: {
            line: 143,
            column: 3
          }
        },
        line: 138
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 21,
            column: 2
          },
          end: {
            line: 21,
            column: 14
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 21,
            column: 9
          },
          end: {
            line: 21,
            column: 14
          }
        }],
        line: 21
      },
      "1": {
        loc: {
          start: {
            line: 27,
            column: 17
          },
          end: {
            line: 27,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 27,
            column: 17
          },
          end: {
            line: 27,
            column: 24
          }
        }, {
          start: {
            line: 27,
            column: 28
          },
          end: {
            line: 27,
            column: 44
          }
        }],
        line: 27
      },
      "2": {
        loc: {
          start: {
            line: 28,
            column: 17
          },
          end: {
            line: 28,
            column: 79
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 28,
            column: 17
          },
          end: {
            line: 28,
            column: 27
          }
        }, {
          start: {
            line: 28,
            column: 32
          },
          end: {
            line: 28,
            column: 49
          }
        }, {
          start: {
            line: 28,
            column: 53
          },
          end: {
            line: 28,
            column: 78
          }
        }],
        line: 28
      },
      "3": {
        loc: {
          start: {
            line: 38,
            column: 30
          },
          end: {
            line: 38,
            column: 98
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 38,
            column: 71
          },
          end: {
            line: 38,
            column: 93
          }
        }, {
          start: {
            line: 38,
            column: 96
          },
          end: {
            line: 38,
            column: 98
          }
        }],
        line: 38
      },
      "4": {
        loc: {
          start: {
            line: 38,
            column: 31
          },
          end: {
            line: 38,
            column: 67
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 38,
            column: 31
          },
          end: {
            line: 38,
            column: 41
          }
        }, {
          start: {
            line: 38,
            column: 45
          },
          end: {
            line: 38,
            column: 67
          }
        }],
        line: 38
      },
      "5": {
        loc: {
          start: {
            line: 45,
            column: 4
          },
          end: {
            line: 47,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 45,
            column: 4
          },
          end: {
            line: 47,
            column: 5
          }
        }, {
          start: {
            line: 45,
            column: 4
          },
          end: {
            line: 47,
            column: 5
          }
        }],
        line: 45
      },
      "6": {
        loc: {
          start: {
            line: 51,
            column: 4
          },
          end: {
            line: 62,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 51,
            column: 4
          },
          end: {
            line: 62,
            column: 5
          }
        }, {
          start: {
            line: 51,
            column: 4
          },
          end: {
            line: 62,
            column: 5
          }
        }],
        line: 51
      },
      "7": {
        loc: {
          start: {
            line: 51,
            column: 8
          },
          end: {
            line: 51,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 51,
            column: 8
          },
          end: {
            line: 51,
            column: 14
          }
        }, {
          start: {
            line: 51,
            column: 18
          },
          end: {
            line: 51,
            column: 28
          }
        }, {
          start: {
            line: 51,
            column: 32
          },
          end: {
            line: 51,
            column: 40
          }
        }],
        line: 51
      },
      "8": {
        loc: {
          start: {
            line: 68,
            column: 4
          },
          end: {
            line: 80,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 68,
            column: 4
          },
          end: {
            line: 80,
            column: 5
          }
        }, {
          start: {
            line: 68,
            column: 4
          },
          end: {
            line: 80,
            column: 5
          }
        }],
        line: 68
      },
      "9": {
        loc: {
          start: {
            line: 68,
            column: 8
          },
          end: {
            line: 68,
            column: 28
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 68,
            column: 8
          },
          end: {
            line: 68,
            column: 14
          }
        }, {
          start: {
            line: 68,
            column: 18
          },
          end: {
            line: 68,
            column: 28
          }
        }],
        line: 68
      },
      "10": {
        loc: {
          start: {
            line: 76,
            column: 6
          },
          end: {
            line: 79,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 76,
            column: 6
          },
          end: {
            line: 79,
            column: 7
          }
        }, {
          start: {
            line: 76,
            column: 6
          },
          end: {
            line: 79,
            column: 7
          }
        }],
        line: 76
      },
      "11": {
        loc: {
          start: {
            line: 84,
            column: 4
          },
          end: {
            line: 86,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 84,
            column: 4
          },
          end: {
            line: 86,
            column: 5
          }
        }, {
          start: {
            line: 84,
            column: 4
          },
          end: {
            line: 86,
            column: 5
          }
        }],
        line: 84
      },
      "12": {
        loc: {
          start: {
            line: 84,
            column: 8
          },
          end: {
            line: 84,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 84,
            column: 8
          },
          end: {
            line: 84,
            column: 19
          }
        }, {
          start: {
            line: 84,
            column: 23
          },
          end: {
            line: 84,
            column: 40
          }
        }],
        line: 84
      },
      "13": {
        loc: {
          start: {
            line: 88,
            column: 4
          },
          end: {
            line: 90,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 88,
            column: 4
          },
          end: {
            line: 90,
            column: 5
          }
        }, {
          start: {
            line: 88,
            column: 4
          },
          end: {
            line: 90,
            column: 5
          }
        }],
        line: 88
      },
      "14": {
        loc: {
          start: {
            line: 95,
            column: 4
          },
          end: {
            line: 100,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 95,
            column: 4
          },
          end: {
            line: 100,
            column: 5
          }
        }, {
          start: {
            line: 95,
            column: 4
          },
          end: {
            line: 100,
            column: 5
          }
        }],
        line: 95
      },
      "15": {
        loc: {
          start: {
            line: 104,
            column: 4
          },
          end: {
            line: 112,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 104,
            column: 4
          },
          end: {
            line: 112,
            column: 5
          }
        }, {
          start: {
            line: 104,
            column: 4
          },
          end: {
            line: 112,
            column: 5
          }
        }],
        line: 104
      },
      "16": {
        loc: {
          start: {
            line: 109,
            column: 6
          },
          end: {
            line: 111,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 109,
            column: 6
          },
          end: {
            line: 111,
            column: 7
          }
        }, {
          start: {
            line: 109,
            column: 6
          },
          end: {
            line: 111,
            column: 7
          }
        }],
        line: 109
      },
      "17": {
        loc: {
          start: {
            line: 116,
            column: 23
          },
          end: {
            line: 116,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 116,
            column: 23
          },
          end: {
            line: 116,
            column: 28
          }
        }, {
          start: {
            line: 116,
            column: 32
          },
          end: {
            line: 116,
            column: 40
          }
        }, {
          start: {
            line: 116,
            column: 44
          },
          end: {
            line: 116,
            column: 52
          }
        }],
        line: 116
      },
      "18": {
        loc: {
          start: {
            line: 117,
            column: 21
          },
          end: {
            line: 117,
            column: 67
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 117,
            column: 21
          },
          end: {
            line: 117,
            column: 25
          }
        }, {
          start: {
            line: 117,
            column: 29
          },
          end: {
            line: 117,
            column: 37
          }
        }, {
          start: {
            line: 117,
            column: 41
          },
          end: {
            line: 117,
            column: 67
          }
        }],
        line: 117
      },
      "19": {
        loc: {
          start: {
            line: 119,
            column: 4
          },
          end: {
            line: 121,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 119,
            column: 4
          },
          end: {
            line: 121,
            column: 5
          }
        }, {
          start: {
            line: 119,
            column: 4
          },
          end: {
            line: 121,
            column: 5
          }
        }],
        line: 119
      },
      "20": {
        loc: {
          start: {
            line: 119,
            column: 8
          },
          end: {
            line: 119,
            column: 28
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 119,
            column: 8
          },
          end: {
            line: 119,
            column: 17
          }
        }, {
          start: {
            line: 119,
            column: 21
          },
          end: {
            line: 119,
            column: 28
          }
        }],
        line: 119
      },
      "21": {
        loc: {
          start: {
            line: 124,
            column: 23
          },
          end: {
            line: 124,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 124,
            column: 23
          },
          end: {
            line: 124,
            column: 32
          }
        }, {
          start: {
            line: 124,
            column: 36
          },
          end: {
            line: 124,
            column: 54
          }
        }],
        line: 124
      },
      "22": {
        loc: {
          start: {
            line: 127,
            column: 4
          },
          end: {
            line: 129,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 127,
            column: 4
          },
          end: {
            line: 129,
            column: 5
          }
        }, {
          start: {
            line: 127,
            column: 4
          },
          end: {
            line: 129,
            column: 5
          }
        }],
        line: 127
      },
      "23": {
        loc: {
          start: {
            line: 127,
            column: 8
          },
          end: {
            line: 127,
            column: 34
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 127,
            column: 8
          },
          end: {
            line: 127,
            column: 20
          }
        }, {
          start: {
            line: 127,
            column: 24
          },
          end: {
            line: 127,
            column: 34
          }
        }],
        line: 127
      },
      "24": {
        loc: {
          start: {
            line: 133,
            column: 4
          },
          end: {
            line: 135,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 133,
            column: 4
          },
          end: {
            line: 135,
            column: 5
          }
        }, {
          start: {
            line: 133,
            column: 4
          },
          end: {
            line: 135,
            column: 5
          }
        }],
        line: 133
      },
      "25": {
        loc: {
          start: {
            line: 133,
            column: 8
          },
          end: {
            line: 133,
            column: 27
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 133,
            column: 8
          },
          end: {
            line: 133,
            column: 19
          }
        }, {
          start: {
            line: 133,
            column: 23
          },
          end: {
            line: 133,
            column: 27
          }
        }],
        line: 133
      },
      "26": {
        loc: {
          start: {
            line: 139,
            column: 4
          },
          end: {
            line: 142,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 139,
            column: 4
          },
          end: {
            line: 142,
            column: 5
          }
        }, {
          start: {
            line: 139,
            column: 4
          },
          end: {
            line: 142,
            column: 5
          }
        }],
        line: 139
      },
      "27": {
        loc: {
          start: {
            line: 155,
            column: 12
          },
          end: {
            line: 161,
            column: 5
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 155,
            column: 12
          },
          end: {
            line: 155,
            column: 22
          }
        }, {
          start: {
            line: 156,
            column: 6
          },
          end: {
            line: 160,
            column: 8
          }
        }],
        line: 155
      },
      "28": {
        loc: {
          start: {
            line: 162,
            column: 12
          },
          end: {
            line: 162,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 162,
            column: 12
          },
          end: {
            line: 162,
            column: 22
          }
        }, {
          start: {
            line: 162,
            column: 26
          },
          end: {
            line: 162,
            column: 47
          }
        }],
        line: 162
      },
      "29": {
        loc: {
          start: {
            line: 163,
            column: 14
          },
          end: {
            line: 169,
            column: 5
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 163,
            column: 14
          },
          end: {
            line: 163,
            column: 24
          }
        }, {
          start: {
            line: 163,
            column: 28
          },
          end: {
            line: 163,
            column: 32
          }
        }, {
          start: {
            line: 164,
            column: 6
          },
          end: {
            line: 168,
            column: 8
          }
        }],
        line: 163
      },
      "30": {
        loc: {
          start: {
            line: 174,
            column: 2
          },
          end: {
            line: 182,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 174,
            column: 2
          },
          end: {
            line: 182,
            column: 3
          }
        }, {
          start: {
            line: 174,
            column: 2
          },
          end: {
            line: 182,
            column: 3
          }
        }],
        line: 174
      },
      "31": {
        loc: {
          start: {
            line: 176,
            column: 9
          },
          end: {
            line: 182,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 176,
            column: 9
          },
          end: {
            line: 182,
            column: 3
          }
        }, {
          start: {
            line: 176,
            column: 9
          },
          end: {
            line: 182,
            column: 3
          }
        }],
        line: 176
      },
      "32": {
        loc: {
          start: {
            line: 177,
            column: 4
          },
          end: {
            line: 181,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 177,
            column: 4
          },
          end: {
            line: 181,
            column: 5
          }
        }, {
          start: {
            line: 177,
            column: 4
          },
          end: {
            line: 181,
            column: 5
          }
        }],
        line: 177
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    b: {
      "0": [0],
      "1": [0, 0],
      "2": [0, 0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0, 0],
      "18": [0, 0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "ea63f106e463ef3ea550a0018ba2ec4740364486"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useDeepCompareEffect = _interopRequireDefault(require("use-deep-compare-effect"));

var _helpers = require("./helpers");

var _ = require("..");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function useFile(_ref) {
  var authentication = _ref.authentication,
      repository = _ref.repository,
      filepath = _ref.filepath,
      onFilepath = _ref.onFilepath,
      defaultContent = _ref.defaultContent,
      _config = _ref.config,
      _ref$create = _ref.create,
      create = _ref$create === void 0 ? (cov_du7neo097.b[0][0]++, false) : _ref$create;
  cov_du7neo097.f[0]++;

  var _ref2 = (cov_du7neo097.s[0]++, (0, _react.useState)()),
      _ref3 = _slicedToArray(_ref2, 2),
      file = _ref3[0],
      setFile = _ref3[1];

  var _ref4 = (cov_du7neo097.s[1]++, (0, _react.useState)()),
      _ref5 = _slicedToArray(_ref4, 2),
      blob = _ref5[0],
      setBlob = _ref5[1];

  var _ref6 = (cov_du7neo097.s[2]++, (0, _react.useContext)(_.RepositoryContext)),
      updateBranch = _ref6.actions.updateBranch,
      repositoryConfig = _ref6.config;

  var config = (cov_du7neo097.s[3]++, (cov_du7neo097.b[1][0]++, _config) || (cov_du7neo097.b[1][1]++, repositoryConfig));
  var branch = (cov_du7neo097.s[4]++, (cov_du7neo097.b[2][0]++, repository) && ((cov_du7neo097.b[2][1]++, repository.branch) || (cov_du7neo097.b[2][2]++, repository.default_branch)));

  var _ref7 = (cov_du7neo097.s[5]++, (0, _react.useState)()),
      _ref8 = _slicedToArray(_ref7, 2),
      deleted = _ref8[0],
      setDeleted = _ref8[1];

  var _ref9 = (cov_du7neo097.s[6]++, (0, _.useBlob)({
    blob: blob,
    onBlob: setBlob,
    config: config,
    repository: repository,
    filepath: filepath
  })),
      blobState = _ref9.state,
      blobActions = _ref9.actions,
      blobComponents = _ref9.components;

  var _ref10 = (cov_du7neo097.s[7]++, (cov_du7neo097.b[4][0]++, repository) && (cov_du7neo097.b[4][1]++, repository.permissions) ? (cov_du7neo097.b[3][0]++, repository.permissions) : (cov_du7neo097.b[3][1]++, {})),
      writeable = _ref10.push;

  var update = (cov_du7neo097.s[8]++, (0, _react.useCallback)(function (_file) {
    cov_du7neo097.f[1]++;
    cov_du7neo097.s[9]++;
    setFile(_file);
  }, []));
  var read = (cov_du7neo097.s[10]++, (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_filepath) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              cov_du7neo097.f[2]++;
              cov_du7neo097.s[11]++;

              if (!onFilepath) {
                _context.next = 9;
                break;
              }

              cov_du7neo097.b[5][0]++;
              cov_du7neo097.s[12]++;
              _context.next = 7;
              return onFilepath(_filepath);

            case 7:
              _context.next = 10;
              break;

            case 9:
              cov_du7neo097.b[5][1]++;

            case 10:
              ;

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref11.apply(this, arguments);
    };
  }(), [onFilepath]));
  var load = (cov_du7neo097.s[13]++, (0, _react.useCallback)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var _file, content;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            cov_du7neo097.f[3]++;
            cov_du7neo097.s[14]++;

            if (!((cov_du7neo097.b[7][0]++, config) && (cov_du7neo097.b[7][1]++, repository) && (cov_du7neo097.b[7][2]++, filepath))) {
              _context2.next = 16;
              break;
            }

            cov_du7neo097.b[6][0]++;
            cov_du7neo097.s[15]++;
            _context2.next = 7;
            return (0, _helpers.ensureFile)({
              filepath: filepath,
              defaultContent: defaultContent,
              authentication: authentication,
              config: config,
              repository: repository,
              branch: branch
            });

          case 7:
            _file = _context2.sent;
            cov_du7neo097.s[16]++;
            _context2.next = 11;
            return (0, _helpers.getContentFromFile)(_file);

          case 11:
            content = _context2.sent;
            cov_du7neo097.s[17]++;
            update(_objectSpread({}, _file, {
              branch: branch,
              content: content,
              filepath: _file.path
            }));
            _context2.next = 17;
            break;

          case 16:
            cov_du7neo097.b[6][1]++;

          case 17:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), [authentication, branch, config, defaultContent, filepath, repository, update]));
  var createFile = (cov_du7neo097.s[18]++, (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref13) {
      var _branch, _filepath, _defaultContent, _file;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _branch = _ref13.branch, _filepath = _ref13.filepath, _defaultContent = _ref13.defaultContent;
              cov_du7neo097.f[4]++;
              cov_du7neo097.s[19]++;

              if (!((cov_du7neo097.b[9][0]++, config) && (cov_du7neo097.b[9][1]++, repository))) {
                _context3.next = 14;
                break;
              }

              cov_du7neo097.b[8][0]++;
              cov_du7neo097.s[20]++;
              _context3.next = 8;
              return (0, _helpers.ensureFile)({
                authentication: authentication,
                config: config,
                repository: repository,
                branch: _branch,
                filepath: _filepath,
                defaultContent: _defaultContent
              });

            case 8:
              _file = _context3.sent;
              cov_du7neo097.s[21]++;

              if (_file) {
                cov_du7neo097.b[10][0]++;
                cov_du7neo097.s[22]++;
                updateBranch(_branch);
                cov_du7neo097.s[23]++;
                onFilepath(_filepath);
              } else {
                cov_du7neo097.b[10][1]++;
              }

              ;
              _context3.next = 15;
              break;

            case 14:
              cov_du7neo097.b[8][1]++;

            case 15:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x2) {
      return _ref14.apply(this, arguments);
    };
  }(), [authentication, config, repository, updateBranch, onFilepath]));
  var close = (cov_du7neo097.s[24]++, (0, _react.useCallback)(function () {
    cov_du7neo097.f[5]++;
    cov_du7neo097.s[25]++;

    if ((cov_du7neo097.b[12][0]++, blobActions) && (cov_du7neo097.b[12][1]++, blobActions.close)) {
      cov_du7neo097.b[11][0]++;
      cov_du7neo097.s[26]++;
      blobActions.close();
    } else {
      cov_du7neo097.b[11][1]++;
    }

    ;
    cov_du7neo097.s[27]++;

    if (onFilepath) {
      cov_du7neo097.b[13][0]++;
      cov_du7neo097.s[28]++;
      onFilepath();
    } else {
      cov_du7neo097.b[13][1]++;
    }

    ;
    cov_du7neo097.s[29]++;
    update();
  }, [update, blobActions, onFilepath]));
  var save = (cov_du7neo097.s[30]++, (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(content) {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              cov_du7neo097.f[6]++;
              cov_du7neo097.s[31]++;

              if (!writeable) {
                _context4.next = 12;
                break;
              }

              cov_du7neo097.b[14][0]++;
              cov_du7neo097.s[32]++;
              _context4.next = 7;
              return (0, _helpers.saveFile)({
                authentication: authentication,
                repository: repository,
                branch: branch,
                file: file,
                content: content
              });

            case 7:
              cov_du7neo097.s[33]++;
              _context4.next = 10;
              return load();

            case 10:
              _context4.next = 13;
              break;

            case 12:
              cov_du7neo097.b[14][1]++;

            case 13:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x3) {
      return _ref15.apply(this, arguments);
    };
  }(), [writeable, authentication, repository, branch, file, load]));
  var dangerouslyDelete = (cov_du7neo097.s[34]++, (0, _react.useCallback)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    var _deleted;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            cov_du7neo097.f[7]++;
            cov_du7neo097.s[35]++;

            if (!writeable) {
              _context5.next = 12;
              break;
            }

            cov_du7neo097.b[15][0]++;
            cov_du7neo097.s[36]++;
            _context5.next = 7;
            return (0, _helpers.deleteFile)({
              authentication: authentication,
              repository: repository,
              file: file,
              branch: branch
            });

          case 7:
            _deleted = _context5.sent;
            cov_du7neo097.s[37]++;

            if (_deleted) {
              cov_du7neo097.b[16][0]++;
              cov_du7neo097.s[38]++;
              setDeleted(true);
            } else {
              cov_du7neo097.b[16][1]++;
            }

            _context5.next = 13;
            break;

          case 12:
            cov_du7neo097.b[15][1]++;

          case 13:
            ;

          case 14:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  })), [file, authentication, branch, repository, writeable]));
  cov_du7neo097.s[39]++;
  (0, _useDeepCompareEffect.default)(function () {
    cov_du7neo097.f[8]++;
    var notLoaded = (cov_du7neo097.s[40]++, (cov_du7neo097.b[17][0]++, !file) && (cov_du7neo097.b[17][1]++, filepath) && (cov_du7neo097.b[17][2]++, !deleted));
    var loadNew = (cov_du7neo097.s[41]++, (cov_du7neo097.b[18][0]++, file) && (cov_du7neo097.b[18][1]++, filepath) && (cov_du7neo097.b[18][2]++, file.filepath !== filepath));
    cov_du7neo097.s[42]++;

    if ((cov_du7neo097.b[20][0]++, notLoaded) || (cov_du7neo097.b[20][1]++, loadNew)) {
      cov_du7neo097.b[19][0]++;
      cov_du7neo097.s[43]++;
      load();
    } else {
      cov_du7neo097.b[19][1]++;
    }
  }, [deleted, filepath, load, file]);
  var blobFilepath = (cov_du7neo097.s[44]++, (cov_du7neo097.b[21][0]++, blobState) && (cov_du7neo097.b[21][1]++, blobState.filepath));
  cov_du7neo097.s[45]++;
  (0, _useDeepCompareEffect.default)(function () {
    cov_du7neo097.f[9]++;
    cov_du7neo097.s[46]++;

    if ((cov_du7neo097.b[23][0]++, blobFilepath) && (cov_du7neo097.b[23][1]++, onFilepath)) {
      cov_du7neo097.b[22][0]++;
      cov_du7neo097.s[47]++;
      onFilepath(blobFilepath);
    } else {
      cov_du7neo097.b[22][1]++;
    }

    ;
  }, [blobFilepath, onFilepath]);
  cov_du7neo097.s[48]++;
  (0, _useDeepCompareEffect.default)(function () {
    cov_du7neo097.f[10]++;
    cov_du7neo097.s[49]++; // if there is a file but no repository, close file.

    if ((cov_du7neo097.b[25][0]++, !repository) && (cov_du7neo097.b[25][1]++, file)) {
      cov_du7neo097.b[24][0]++;
      cov_du7neo097.s[50]++;
      close();
    } else {
      cov_du7neo097.b[24][1]++;
    }

    ;
  }, [repository, file, close]);
  cov_du7neo097.s[51]++;
  (0, _useDeepCompareEffect.default)(function () {
    cov_du7neo097.f[11]++;
    cov_du7neo097.s[52]++;

    if (deleted) {
      cov_du7neo097.b[26][0]++;
      cov_du7neo097.s[53]++;
      close();
      cov_du7neo097.s[54]++;
      setDeleted(false);
    } else {
      cov_du7neo097.b[26][1]++;
    }

    ;
  }, [deleted, close]);
  var actions = (cov_du7neo097.s[55]++, {
    update: update,
    load: load,
    read: read,
    save: save,
    close: close,
    dangerouslyDelete: dangerouslyDelete
  });
  var components = (cov_du7neo097.s[56]++, {
    create: (cov_du7neo097.b[27][0]++, repository) && (cov_du7neo097.b[27][1]++, /*#__PURE__*/_react.default.createElement(_.FileForm, {
      branch: branch,
      defaultContent: defaultContent,
      onSubmit: createFile
    })),
    browse: (cov_du7neo097.b[28][0]++, repository) && (cov_du7neo097.b[28][1]++, blobComponents.browse),
    fileCard: (cov_du7neo097.b[29][0]++, repository) && (cov_du7neo097.b[29][1]++, file) && (cov_du7neo097.b[29][2]++, /*#__PURE__*/_react.default.createElement(_.FileCard, {
      authentication: authentication,
      repository: repository,
      file: _objectSpread({}, file, {}, actions)
    }))
  });
  var component = (cov_du7neo097.s[57]++, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null));
  cov_du7neo097.s[58]++;

  if (file) {
    cov_du7neo097.b[30][0]++;
    cov_du7neo097.s[59]++;
    component = components.fileCard;
  } else {
    cov_du7neo097.b[30][1]++;
    cov_du7neo097.s[60]++;

    if (!filepath) {
      cov_du7neo097.b[31][0]++;
      cov_du7neo097.s[61]++;

      if (create) {
        cov_du7neo097.b[32][0]++;
        cov_du7neo097.s[62]++;
        component = components.create;
      } else {
        cov_du7neo097.b[32][1]++;
        cov_du7neo097.s[63]++;
        component = components.browse;
      }
    } else {
      cov_du7neo097.b[31][1]++;
    }
  }

  cov_du7neo097.s[64]++;
  return {
    state: file,
    actions: actions,
    component: component,
    components: components
  };
}

;
cov_du7neo097.s[65]++;
useFile.propTypes = {
  /** The full filepath for the file. */
  filepath: _propTypes.default.string,

  /** Function to propogate filepath when the Blob is selected. */
  onFilepath: _propTypes.default.func,

  /** Authentication object returned from a successful withAuthentication login. */
  authentication: _propTypes.default.shape({
    config: _propTypes.default.shape({
      server: _propTypes.default.string.isRequired,
      headers: _propTypes.default.shape({
        Authorization: _propTypes.default.string.isRequired
      }).isRequired
    }).isRequired,
    user: _propTypes.default.shape({
      username: _propTypes.default.string.isRequired,
      email: _propTypes.default.string.isRequired
    }).isRequired
  }),

  /** Repository tree_url can be used in place of blobConfig */
  repository: _propTypes.default.shape({
    owner: _propTypes.default.shape({
      username: _propTypes.default.string.isRequired
    }),
    name: _propTypes.default.string.isRequired
  }).isRequired,

  /** use a form to create a new file */
  create: _propTypes.default.bool
};
var _default = useFile;
exports.default = _default;